import { render, staticRenderFns } from "./AAsignacionTablartxs2.vue?vue&type=template&id=3489f32d"
import script from "./AAsignacionTablartxs2.vue?vue&type=script&lang=js"
export * from "./AAsignacionTablartxs2.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionTablartxs2.vue?vue&type=style&index=0&id=3489f32d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports